import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4465b420 from 'nuxt_plugin_sentryserver_4465b420' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7813b468 from 'nuxt_plugin_sentryclient_7813b468' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_42bab598 from 'nuxt_plugin_plugin_42bab598' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_6c2597b1 from 'nuxt_plugin_plugin_6c2597b1' // Source: ./matomo/plugin.js (mode: 'client')
import nuxt_plugin_image_19114f27 from 'nuxt_plugin_image_19114f27' // Source: ./image.js (mode: 'all')
import nuxt_plugin_plugin_53a2be01 from 'nuxt_plugin_plugin_53a2be01' // Source: ./xhr-cache/plugin.js (mode: 'all')
import nuxt_plugin_dayjsplugin_3974059e from 'nuxt_plugin_dayjsplugin_3974059e' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_910681b6 from 'nuxt_plugin_vuesocialsharingplugin_910681b6' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_featuretoggles_1fd8c3da from 'nuxt_plugin_featuretoggles_1fd8c3da' // Source: ./feature-toggles.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_httpserver_39c793ce from 'nuxt_plugin_httpserver_39c793ce' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_5d0acaa4 from 'nuxt_plugin_http_5d0acaa4' // Source: ./http.js (mode: 'all')
import nuxt_plugin_strapi_24aef403 from 'nuxt_plugin_strapi_24aef403' // Source: ./strapi.js (mode: 'all')
import nuxt_plugin_markdownit_f3de385c from 'nuxt_plugin_markdownit_f3de385c' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_apollomodule_079e31f8 from 'nuxt_plugin_apollomodule_079e31f8' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_568eec48 from 'nuxt_plugin_workbox_568eec48' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_737b6b5b from 'nuxt_plugin_metaplugin_737b6b5b' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_localforage_132dcbc1 from 'nuxt_plugin_localforage_132dcbc1' // Source: ./localforage.js (mode: 'client')
import nuxt_plugin_deviceplugin_001a0492 from 'nuxt_plugin_deviceplugin_001a0492' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_cache_223a920e from 'nuxt_plugin_cache_223a920e' // Source: ../plugins/cache (mode: 'all')
import nuxt_plugin_cachedstrapi_1689d7e0 from 'nuxt_plugin_cachedstrapi_1689d7e0' // Source: ../plugins/cached-strapi (mode: 'all')
import nuxt_plugin_jsonld_320ccf54 from 'nuxt_plugin_jsonld_320ccf54' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_notifications_3edb2b74 from 'nuxt_plugin_notifications_3edb2b74' // Source: ../plugins/notifications (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_workbox_142ebb03 from 'nuxt_plugin_workbox_142ebb03' // Source: ../plugins/workbox.force-reload (mode: 'client')
import nuxt_plugin_xhrcache_350d2603 from 'nuxt_plugin_xhrcache_350d2603' // Source: ../plugins/xhr-cache (mode: 'all')
import nuxt_plugin_xhrcachedstrapi_6897a6d5 from 'nuxt_plugin_xhrcachedstrapi_6897a6d5' // Source: ../plugins/xhr-cached-strapi (mode: 'all')
import nuxt_plugin_growthbook_2eb1b624 from 'nuxt_plugin_growthbook_2eb1b624' // Source: ../plugins/growthbook (mode: 'all')
import nuxt_plugin_router_3f7e063d from 'nuxt_plugin_router_3f7e063d' // Source: ../plugins/router (mode: 'client')
import nuxt_plugin_auth_271f3cf8 from 'nuxt_plugin_auth_271f3cf8' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_716fdb49 from 'nuxt_plugin_auth_716fdb49' // Source: ../plugins/auth._switch_user (mode: 'all')
import nuxt_plugin_auth_5b2c45ab from 'nuxt_plugin_auth_5b2c45ab' // Source: ../plugins/auth.events (mode: 'all')
import nuxt_plugin_auth_6ce4d3ce from 'nuxt_plugin_auth_6ce4d3ce' // Source: ../plugins/auth.showJobAsPublished (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":(titleChunk) => {
      const siteName = 'Promotionbasis';
      return titleChunk ?
      `${titleChunk} | ${siteName}` :
      'Promotionjobs | Messejobs | Eventjobs | Promotionbasis';
    },"htmlAttrs":{"lang":"de"},"title":"Promotionjobs | Messejobs | Eventjobs","meta":[{"name":"color-scheme","content":"light"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"language","name":"language","content":"de"},{"hid":"keywords","name":"keywords","content":"Promotionjobs, Messejobs, Eventjobs, Studentenjobs, Nebenjobs, Ferienjobs, Gastrojobs, Schülerjobs, Rentnerjobs"},{"hid":"description","name":"description","content":"Deutschlands große Plattform für Promotionjobs, Messejobs und Eventjobs. Ob Student, Schüler oder Rentner - bei uns findest du deinen nächsten Job."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[{"src":"https:\u002F\u002Fanalytics.promotionbasis.de\u002Fmatomo.js","body":true,"defer":true,"async":true}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4465b420 === 'function') {
    await nuxt_plugin_sentryserver_4465b420(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7813b468 === 'function') {
    await nuxt_plugin_sentryclient_7813b468(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_42bab598 === 'function') {
    await nuxt_plugin_plugin_42bab598(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin_6c2597b1 === 'function') {
    await nuxt_plugin_plugin_6c2597b1(app.context, inject)
  }

  if (typeof nuxt_plugin_image_19114f27 === 'function') {
    await nuxt_plugin_image_19114f27(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_53a2be01 === 'function') {
    await nuxt_plugin_plugin_53a2be01(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_3974059e === 'function') {
    await nuxt_plugin_dayjsplugin_3974059e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_910681b6 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_910681b6(app.context, inject)
  }

  if (typeof nuxt_plugin_featuretoggles_1fd8c3da === 'function') {
    await nuxt_plugin_featuretoggles_1fd8c3da(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_39c793ce === 'function') {
    await nuxt_plugin_httpserver_39c793ce(app.context, inject)
  }

  if (typeof nuxt_plugin_http_5d0acaa4 === 'function') {
    await nuxt_plugin_http_5d0acaa4(app.context, inject)
  }

  if (typeof nuxt_plugin_strapi_24aef403 === 'function') {
    await nuxt_plugin_strapi_24aef403(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_f3de385c === 'function') {
    await nuxt_plugin_markdownit_f3de385c(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_079e31f8 === 'function') {
    await nuxt_plugin_apollomodule_079e31f8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_568eec48 === 'function') {
    await nuxt_plugin_workbox_568eec48(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_737b6b5b === 'function') {
    await nuxt_plugin_metaplugin_737b6b5b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localforage_132dcbc1 === 'function') {
    await nuxt_plugin_localforage_132dcbc1(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_001a0492 === 'function') {
    await nuxt_plugin_deviceplugin_001a0492(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_cache_223a920e === 'function') {
    await nuxt_plugin_cache_223a920e(app.context, inject)
  }

  if (typeof nuxt_plugin_cachedstrapi_1689d7e0 === 'function') {
    await nuxt_plugin_cachedstrapi_1689d7e0(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_320ccf54 === 'function') {
    await nuxt_plugin_jsonld_320ccf54(app.context, inject)
  }

  if (typeof nuxt_plugin_notifications_3edb2b74 === 'function') {
    await nuxt_plugin_notifications_3edb2b74(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_142ebb03 === 'function') {
    await nuxt_plugin_workbox_142ebb03(app.context, inject)
  }

  if (typeof nuxt_plugin_xhrcache_350d2603 === 'function') {
    await nuxt_plugin_xhrcache_350d2603(app.context, inject)
  }

  if (typeof nuxt_plugin_xhrcachedstrapi_6897a6d5 === 'function') {
    await nuxt_plugin_xhrcachedstrapi_6897a6d5(app.context, inject)
  }

  if (typeof nuxt_plugin_growthbook_2eb1b624 === 'function') {
    await nuxt_plugin_growthbook_2eb1b624(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_router_3f7e063d === 'function') {
    await nuxt_plugin_router_3f7e063d(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_271f3cf8 === 'function') {
    await nuxt_plugin_auth_271f3cf8(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_716fdb49 === 'function') {
    await nuxt_plugin_auth_716fdb49(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_5b2c45ab === 'function') {
    await nuxt_plugin_auth_5b2c45ab(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6ce4d3ce === 'function') {
    await nuxt_plugin_auth_6ce4d3ce(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
